module.exports = __webpack_public_path__ + "img/healthicons.c7411a82.svg";